module.exports = __webpack_public_path__ + "static/media/ic_quote_left.5e818752.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/ic_quote_left.svg
// module id = 125
// module chunks = 0